import React from "react";
import { useHistory } from "react-router-dom";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const RecentlySoldBanner = ({ items = [] }) => {
  const history = useHistory();
  if (!items || items.length === 0) return null;

  return (
    <div className="w-full bg-gradient-to-b from-amber-50/90 to-amber-100/50 border-y border-amber-200/70 py-5 mb-6 overflow-hidden">
      <div className="flex items-center gap-2 mb-4 px-4 md:px-6">
        <span className="text-amber-900 font-bold text-lg tracking-tight">Recently Sold</span>
        {/* <span className="text-amber-700/70 text-sm">— last 10 items</span> */}
      </div>
      <div className="relative overflow-hidden">
        <div className="flex animate-scroll-banner gap-5 px-4 md:px-6 w-max inline-flex">
          {[...items, ...items].map((item, index) => {
            const name = item.product_name ?? item.title ?? item.product_details?.title ?? "—";
            const type = item.type ?? item.product_type ?? item.product_details?.product_type ?? "—";
            const price = item.price ?? item.selling_price ?? item.product_details?.selling_price ?? item.mrp ?? item.product_details?.mrp ?? "—";
            const productId = item.product_id ?? item.product_details?.product_id;
            return (
              <div
                key={`${item.product_id ?? item.order_item_id ?? index}-${index}`}
                className="flex-shrink-0 w-[200px] sm:w-[240px] rounded-xl bg-white border border-amber-200/80 shadow-md hover:shadow-lg hover:border-amber-300/90 transition-all duration-300 overflow-hidden"
              >
                <div className="p-3 sm:p-4 flex flex-col gap-2">
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (productId) history.push(`/products/${productId}`);
                    }}
                    className="flex items-start gap-1.5 font-semibold text-gray-800 text-sm leading-tight hover:text-amber-700 focus:outline-none text-left cursor-pointer group w-full"
                    title={name}
                  >
                    <span className="line-clamp-2 flex-1 min-w-0">{name}</span>
                    {productId && <OpenInNewIcon sx={{ fontSize: 16 }} className="flex-shrink-0 text-gray-400 group-hover:text-amber-700 mt-0.5 transition-colors duration-300" />}
                  </button>
                  <div className="flex items-center justify-between gap-2 pt-1 border-t border-amber-100">
                    <span className="text-gray-500 text-xs truncate">{type}</span>
                    <span className="text-amber-700 font-bold text-sm whitespace-nowrap">₹{price}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <style>{`
        @keyframes scroll-banner {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll-banner {
          animation: scroll-banner 25s linear infinite;
          width: max-content;
        }
        .animate-scroll-banner:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default RecentlySoldBanner;
